export const replaceSegmentsFromRoutes = ({
  route,
  params,
  replacer,
}: {
  route: string;
  params: string[];
  replacer: string[];
}) => {
  const wordMap = params.reduce(
    (map, word, index) => {
      map[`:${word}`] = replacer[index];
      return map;
    },
    {} as Record<string, string>
  );

  const regex = new RegExp(`:(${params.join("|")})`, "g");

  return route.replace(regex, (match) => wordMap[match]);
};
